import { createPinia } from 'pinia';
import { useRouter } from 'vue-router';
import { useStateStore } from '@/stores/state';
import {
    loadEnquiry,
    loadBooking,
    restoreStateAndAvailability,
} from '@/helpers/fetchData';

const pinia = createPinia();

export default defineNuxtRouteMiddleware(async (to) => {
    const router = useRouter();
    const stateStore = useStateStore(pinia);

    if (to.path === '/error') {
        return;
    }

    let isAppLoaded = stateStore.isFirstLoad();
    if (!isAppLoaded) {
        isAppLoaded = stateStore.isPageLoaded();
    }
    if (isAppLoaded) {
        return;
    }

    // Check if the route is a specific enquiry or booking route
    const isEnquiryRoute = /^\/enquiry\/[^/]+\/?$/.test(to.path);
    const isBookingRoute = /^\/booking\/[^/]+\/?$/.test(to.path);
    const isLocationRoute = /^\/location\/[^/]+\/?$/.test(to.path);
    const isDirectBookingRoute = /^\/direct-booking\/[^/]+\/?$/.test(to.path);
    const isWalkInRoute = /^\/walk-in\/[^/]+\/?$/.test(to.path);
    const isEnquiryTeamRoute = /^\/enquiry-team\/[^/]+\/?$/.test(to.path);
    const isVirtualConsultationRoute =
        /^\/virtual-consultation\/[^/]+\/?$/.test(to.path);
    const isUpStaffInternalUseRoute =
        /^\/up-staff-internal-use(?:\/[^/]+)?\/?$/.test(to.path);

    if (
        isBookingRoute ||
        isEnquiryRoute ||
        isLocationRoute ||
        isWalkInRoute ||
        isEnquiryTeamRoute ||
        isUpStaffInternalUseRoute ||
        isDirectBookingRoute ||
        isVirtualConsultationRoute
    ) {
        return;
    }

    const request_id = stateStore.getRequestId();
    const mode = stateStore.getMode();
    const location_id = stateStore.getLocationId();

    if (request_id && mode) {
        if (mode === 'NEW') {
            await loadEnquiry(request_id, to.path);
        } else if (mode === 'EXISTING') {
            await loadBooking();
        }
    }

    if (location_id && !isAppLoaded) {
        await restoreStateAndAvailability();
    }

    stateStore.setPageLoadedTrue();
    if (isAppLoaded && !request_id && !location_id) {
        router.push('/error');
        return;
    }
});
